import * as React from 'react';
import { Box, Container } from '@chakra-ui/react';
import { Hero } from '../components/Hero';
import { ReadNext } from '../components/ReadNext';
import { Layout } from '../components/Layout';
import { SectionZone } from '../components/SectionZone';
import { SEO } from '../components/SEO';

export default function Page({ pageContext }) {
  const { sections, readNext, slug, section, image, title, parallaxHero, imageLocation } =
    pageContext || {};

  return (
    <Layout>
      <Hero data={{ image, title, section, slug, parallaxHero, imageLocation }} />
      <Box position='relative' zIndex='1' width='100%' background='white'>
        <Container
          display='flex'
          flexDirection='column'
          maxWidth='container.xl'
          gap={18}
          pb={{ base: 30, md: 60 }}
          px={{ base: 0 }}
        >
          {sections &&
            sections.map((section, index) => (
              <Box as='section' key={section._key || section._id}>
                <SectionZone section={section} index={index} />
              </Box>
            ))}
          {readNext.length ? <ReadNext data={readNext} /> : null}
        </Container>
      </Box>
    </Layout>
  );
}

export const Head = ({ pageContext }) => {
  const { title } = pageContext || {};
  return <SEO title={title} />;
};
